export default __webpack_public_path__ + "static/media/startlater_3@2x.7ab39ae9.jpg";